import React from "react";
import { Divider } from "antd";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  Header,
  KeyStyle,
  Valuestyle,
  ValueWrap,
  DividerWrap,
  DisplayWrap,
  FeeHead,
} from "./styles";
import { FeeTableContainer } from "./styles.js";
import ShowMoreAdminFee from "./../../Components/ShowMoreAdminFee/ShowMoreAdminFee.js";
import { getTitleYearsText } from "./../../Pages/txnUitls";
import { initiateTracking } from "./../../../../utils/commonUtil";

class FeeExpenses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
      showTotal: false
    };
  }

  handleShowMore = () => {
    this.setState({
      show: !this.state.show
    }, () => {
      // Analytic func will call only when Fees & Expenses will open
      if (this.state.show) {
        initiateTracking('showMore', this.props.pageTitle, 'Fees & Expenses', 'Show More');
      }
    });
  };

  handleShowMoreTotal = () => {
    this.setState({
      showTotal: !this.state.showTotal
    });
  };

  render() {
    const yearsText = getTitleYearsText(this.props.selectedVal);
    return (
      <div data-test="transaction-fee-expenses">
        <FeeTableContainer>

          <Header marginBottom="21px">
            {
              (yearsText !== "")
                ?
                `Total administrative fee percentage for ${yearsText}`
                :
                `Total administrative fee percentage for ${this.props.filterMinDate} - ${this.props.filterMaxDate}`
            }
          </Header>
          <ValueWrap marginBottom="20px">
            <KeyStyle paddingRight="14px">Total administrative fee %:</KeyStyle>
            <Valuestyle>{this.props.content.adminFee.administrativeFeeInPercent ? this.props.content.adminFee.administrativeFeeInPercent + '%' : '0%'}</Valuestyle>
          </ValueWrap>
          <DividerWrap marginBottom="29px" MmarginBottom="20px">
            <Divider />
          </DividerWrap>
          <DisplayWrap marginBottom="9px">
            <FeeHead>{this.props.contentData[0].field_title_administrative_fee}</FeeHead>
          </DisplayWrap>
          {
            this.state.show
              ?
              <ShowMoreAdminFee
                field_desc_admin_fee={(this.props.contentData[0].field_desc_admin_fee) ? this.props.contentData[0].field_desc_admin_fee : null}
                field_admin_fee_table={(this.props.contentData[0].field_admin_fee_table) ? this.props.contentData[0].field_admin_fee_table : null}
                field_title_annual_fee_schedule={(this.props.contentData[0].field_title_annual_fee_schedule) ? this.props.contentData[0].field_title_annual_fee_schedule : null}
                field_desc_annual_fee_schedule={(this.props.contentData[0].field_desc_annual_fee_schedule) ? this.props.contentData[0].field_desc_annual_fee_schedule : null}
                field_title_admin_fee_adjustment={(this.props.contentData[0].field_title_admin_fee_adjustment) ? this.props.contentData[0].field_title_admin_fee_adjustment : null}
                field_desc_admin_adjustments={(this.props.contentData[0].field_desc_admin_adjustments) ? this.props.contentData[0].field_desc_admin_adjustments : null}
                field_title_please_note={(this.props.contentData[0].field_title_please_note) ? this.props.contentData[0].field_title_please_note : null}
                field_description_please_note={(this.props.contentData[0].field_description_please_note) ? this.props.contentData[0].field_description_please_note : null}
                field_table={(this.props.contentData[0].field_table) ? this.props.contentData[0].field_table : null}
                field_transaction_footnotes={(this.props.contentData[0].field_transaction_footnotes) ? this.props.contentData[0].field_transaction_footnotes : null}
              />
              : null
          }
        </FeeTableContainer>
      </div>
    );
  }
}

FeeExpenses.propTypes = {
  selectedVal: PropTypes.arrayOf(PropTypes.string),
  filterMaxDate: PropTypes.string,
  filterMinDate: PropTypes.string,
  content: PropTypes.object,
  contentData: PropTypes.array
}

const mapStateToProps = state => ({
  content: state.getIn(["transactionSummary", "feeAndExpenses", "data"]),
  contentData: state.getIn(["transactionSummary", "feeContent", "data"])
});

export default connect(mapStateToProps)(FeeExpenses);
